import {debugLog} from "../Utils/LogUtils";
import {useEffect} from "react";
import moment from "moment/moment";
import {shouldDisplayProvincialGrantOption} from "../Utils/PlanUtils";

export default function useSetBCProvincialGrantBasedOnBirthdate(state) {
    //When the beneficiary birthdate is set, we can set the Canada Learning Bond as long as the bene was born after 2004

    useEffect(() => {
        if (!state.beneficiary.birthdate || state.common.signingProvince !== 'BC') { return; }

        state.setApplication({
            ...state.application,
            grantProvincial: shouldDisplayProvincialGrantOption(state)
        });
        debugLog("useSetCLBBasedOnBirthdate");
    }, [state.beneficiary.birthdate]);



    //TODO: This whole file can probably be removed
}